(() => {
  const popupSelector = '#bundle-recent_sales';

  function productHandleFromPopup(popup) {
    const link = popup.querySelector('.recent-sales-url[data-href], .recent-sales-url[href]');
    const href = link?.dataset?.href || link?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^?#/]+)/);
    return match?.[1] || '';
  }

  async function repairPurchaseImage(popup) {
    if (!popup) return;
    const image = popup.querySelector('.recent-sales-image');
    const frame = popup.querySelector('.recent-sales-product');
    const imageFrame = popup.querySelector('.recent-sales-product-image');
    if (!image || !frame || !imageFrame) return;

    const handle = productHandleFromPopup(popup);
    if (!handle || popup.dataset.miraeeImageHandle === handle) return;
    popup.dataset.miraeeImageHandle = handle;

    frame.style.setProperty('border-radius', '0', 'important');
    frame.style.setProperty('background', '#fff', 'important');
    imageFrame.style.setProperty('border-radius', '0', 'important');
    imageFrame.style.setProperty('background', '#fff', 'important');
    image.style.setProperty('object-fit', 'contain', 'important');
    image.style.setProperty('object-position', 'center', 'important');
    image.style.setProperty('background', '#fff', 'important');

    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const product = await response.json();
      const source = product.featured_image || product.images?.[0];
      if (source) {
        image.src = source.startsWith('//') ? `https:${source}` : source;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    } catch (_error) {
      // The original app image remains in place if the storefront request fails.
    }
  }

  function scan() {
    const popup = document.querySelector(popupSelector);
    if (popup) repairPurchaseImage(popup);
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'data-href', 'style'],
  });
  document.addEventListener('DOMContentLoaded', scan, { once: true });
})();
